import { FC, useLayoutEffect, useRef } from 'react';
import { SocialAuthProps } from '../AuthModal.types';
import {
    YourSituation,
    YourSituationResultProps
} from '@zoopla/onboarding/your-situation';
import { Button } from '@zoopla-eng/zds-components/button';
import { Box } from '@zoopla-eng/zds-components/box';
import { StyledTitle } from './YourSituationQuestion.styles';
import { QuestionContext } from '@zoopla/onboarding/your-situation';

export type YourSituationQuestionProps = {
    page: string;
    onClose?: (goal?: string, lastQuestion?: string) => void;
    buttonText?: 'Close' | 'Continue';
    title?: string;
} & Partial<SocialAuthProps>;

export const YourSituationQuestion: FC<
    React.PropsWithChildren<YourSituationQuestionProps>
> = (props) => {
    const { onClose = () => null, title, page, buttonText = 'Close' } = props;
    const situationHeader = useRef<HTMLHeadingElement>(null);

    const Result: FC<Partial<YourSituationResultProps>> = () => (
        <QuestionContext.Consumer>
            {(value) => {
                const firstQuestionAnswer = value?.answers?.[0].value || '';
                return (
                    <Box maxWidth="238px" display="flex" width="100%">
                        <Button
                            data-testid="your-situation-question-close"
                            category="primary"
                            onClick={() =>
                                onClose(
                                    firstQuestionAnswer,
                                    value?.lastQuestionId
                                )
                            }
                            fw
                        >
                            {buttonText}
                        </Button>
                    </Box>
                );
            }}
        </QuestionContext.Consumer>
    );

    useLayoutEffect(() => {
        if (title && situationHeader?.current) {
            situationHeader.current.focus();
        }
    }, [title]);

    return (
        <div data-testid="your-situation-question">
            {title && (
                <Box pb="$M100">
                    <StyledTitle
                        data-testid="your-situation-heading"
                        tabIndex={-1}
                        ref={situationHeader}
                    >
                        {title}
                    </StyledTitle>
                </Box>
            )}
            <YourSituation
                analyticsPage={page}
                actionAfterQuestionsElement={<Result />}
                onSkip={onClose}
                shouldFocusFirstQuestionOnMount={!title}
            />
        </div>
    );
};
